export default "__VITE_ASSET__Cr8IamoK__"